import { getTemplateFirstChild, replaceNodeChildren } from '../../utils/dom'
import { ShopComponent } from './shop'
import { SidebarComponent } from '../../components/sidebar/sidebar'
import { $el, $elParent } from 'src/scripts/utils/utils'
import { isEnterKey } from 'src/scripts/utils/key'

const FORM_SELECTOR = '[data-filters-form]'
const CHECKBOX_SELECTOR = '[data-filters-checkbox]'
const SHOP_SELECTOR = 'shop-component'
const HEADER_SELECTOR = '[data-filters-header]'
const PRELOADER_SELECTOR = '[data-filters-loading-overlay]'

export class SidebarFilters extends SidebarComponent {
  mountComponent(): void {
    super.mountComponent()

    const form: HTMLFormElement = $el(FORM_SELECTOR, this.element)
    this.addListener(form, 'scroll', this.handleFormScroll)
    this.addListener(form, 'change', this.handleInputChange)
    this.addListener(this, 'click', this.handleClick)
    this.addListener(form, 'keydown', this.handleFormKeydown)
  }

  handleFormScroll = (): void => {
    const form: HTMLFormElement = $el(FORM_SELECTOR, this.element)

    if (form) {
      this.toggleAttribute('header-shadow-visible', form.scrollTop > 0)
    }
  }

  handleClick = (event: MouseEvent): void => {
    const label = $elParent(CHECKBOX_SELECTOR, event.target)

    if (label) {
      label.setAttribute('selected', '')
    }
  }

  handleFormKeydown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()

      const target = event.target as HTMLElement

      if (target.tagName === 'INPUT') {
        target.dispatchEvent(new MouseEvent('click', { button: 0, which: 1 }))
      }
    }
  }

  handleInputChange = (event: InputEvent): void => {
    const target = event.target as HTMLInputElement

    if (target.tagName === 'INPUT') {
      this.change()
    }
  }

  change(): void {
    // re-define in children
  }

  createQuery(): void {
    const form: HTMLFormElement = $el(FORM_SELECTOR, this.element)
    const shop: ShopComponent = $el(SHOP_SELECTOR)

    if (form && shop) {
      const formData = new FormData(form)
      const filterQuery = new URLSearchParams(formData as any).toString()
      shop.filterQuery = filterQuery
    }
  }

  updateHTML(html: Document): void {
    let newElement
    const filterId = this.getAttribute('id')
    const newFilter = filterId ? $el(`#${filterId}`, html) : null

    if (this.hasAttribute('is-open-on-init')) {
      newElement = newFilter ? $el('[data-sidebar-body]', newFilter) : null
    } else {
      const newTemplate = newFilter
        ? $el(`[data-sidebar-template="${this.id}"]`, newFilter)
        : null

      if (newTemplate) {
        newElement = getTemplateFirstChild(newTemplate)
      }
    }

    if (newElement) {
      this.updateFormByElement(newElement)
      this.updateHeaderByElement(newElement)
    }
  }

  updateHeaderByElement(newElement: HTMLElement): void {
    const header = $el(HEADER_SELECTOR, this.element)
    const newHeader = $el(HEADER_SELECTOR, newElement)
    replaceNodeChildren(header, newHeader)
  }

  updateFormByElement(newElement: HTMLElement): void {
    const form = $el(FORM_SELECTOR, this.element)
    const newForm = $el(FORM_SELECTOR, newElement)
    replaceNodeChildren(form, newForm)
  }

  get searchParams(): string {
    const shop: ShopComponent = $el(SHOP_SELECTOR)

    if (!shop) {
      return ''
    }

    return [shop.filterQuery, shop.sortQuery].join('&')
  }

  get preloader(): HTMLElement {
    return $el(PRELOADER_SELECTOR, this.element)
  }
}
